import { useBrandContext } from "@/contexts/brandContext";
import { skipToken, useQuery } from "@apollo/client/react";
import { MyUserWorkspaceDocument } from "@repo/graphql/documents/workspace/query.generated";
import { SubscriptionAbilities } from "@repo/graphql/gql/graphql";

type UseSubscriptionAbilityResult = {
  can: boolean | undefined;
  loading: boolean;
};

export const useSubscriptionAbility = (
  ability: SubscriptionAbilities,
): UseSubscriptionAbilityResult => {
  const { currency } = useBrandContext();
  const { data, loading } = useQuery(
    MyUserWorkspaceDocument,
    currency ? { variables: { walletCurrency: currency } } : skipToken,
  );

  const isLoading = loading && !data;
  const can = isLoading
    ? undefined
    : data?.workspace.myWorkspace?.workspace.subscriptionAbilities.find(
        (s) => s.ability === ability,
      )?.can;

  return { can, loading: isLoading };
};
